import { List } from 'immutable'
import {
  CONTENT_HIGHLIGHTS_ELEVATED_ROLE_IDS,
  CONTENT_HIGHLIGHTS_SUBSCRIPTION_IDS,
} from './entitlements'

export {
  CONTENT_HIGHLIGHTS_ELEVATED_ROLE_IDS,
  CONTENT_HIGHLIGHTS_SUBSCRIPTION_IDS,
} from './entitlements'

function listIncludesAny (list, ids) {
  if (!List.isList(list) || !ids?.length) {
    return false
  }
  return ids.some((id) => list.includes(id))
}

/**
 * Member SKU access (253/280/290) or elevated staff roles.
 */
export function hasContentHighlightsAccess ({ roleIds, subscriptions }) {
  if (listIncludesAny(roleIds, CONTENT_HIGHLIGHTS_ELEVATED_ROLE_IDS)) {
    return true
  }
  return listIncludesAny(subscriptions, CONTENT_HIGHLIGHTS_SUBSCRIPTION_IDS)
}
